module.exports = __webpack_public_path__ + "img/account-summary.f9c3b992.svg";